<template>
  <div class="w-28 text-right text-stone-700 font-normal leading-none flex flex-col gap-1">
    <span
      v-if="isDiscounted"
      class="text-stone-300 text-md line-through"
    >{{ currency(price) }}</span>
    {{ getPrice(price) }}
    <span
      v-if="getUnitPrice(price) && showUnitPrice"
      class="text-sm text-orange-400"
    >
      개당 {{ getUnitPrice(price) }}원
    </span>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {currency, numberFormat} from "@/utils/NumberHelper.js";
import {$t} from "@/i18n/useLanguage.js";
import {useSessionStore} from "@/utils/useSessionStore.js";

const session = useSessionStore()
const props = defineProps({
  price: {
    type: Number,
    default: 0
  },
  discount: {
    type: Number,
    default: 0
  },
  discountType: {
    type: String,
    default: 'rate'
  },
  fixedDiscountAmount: {
    type: Number,
    default: 0
  },
  priceWeight: {
    type: Number,
    default: 0
  },
  baseWeight : {
    type: Number,
    default: 0
  },
  showUnitPrice: {
    type: Boolean,
    default: false
  }
});

const isDiscounted = computed(() => {
  return props.discountType === 'fixed'
    ? props.fixedDiscountAmount > 0
    : props.discount > 0;
});

function getDiscountedPrice(price) {
  let p = price;
  if (props.discountType === 'fixed') {
    return Math.max(0, p - props.fixedDiscountAmount);
  }

  if (props.discount) {
    p = p * (1 - props.discount / 100);
    if(session.isKrw){
      // 1원 자리를 반올림해 10원 단위로 표시합니다.
      p = Math.round(p / 10) * 10;
    }
  }

  return p;
}

function getUnitPrice(price) {
  if(!price){
    return '';
  }
  if(!props.priceWeight || !props.baseWeight){
    return '';
  }

  let p = props.price;
  p = getDiscountedPrice(p);

  const unitPrice = p / (props.priceWeight / props.baseWeight);
  if(unitPrice === props.price){
    return '';
  }
  if(session.getCurrency === 'krw'){
    return numberFormat(unitPrice);
  }else{
    return numberFormat(unitPrice, 2);
  }
}
const getPrice = (value) => {
  let p = value;
  if (!value) {
    return $t("구매불가");
  }
  p = getDiscountedPrice(p);

  return currency(p);
};
</script>
